__webpack_require__.p = "/neue/schupandbach/public/";